import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

// import p1 from 'assests/Photos/Events/Dussasra/1.png'
// import p2 from 'assests/Photos/Events/Dussasra/2.png'
// import p3 from 'assests/Photos/Events/Dussasra/3.png'
// import p4 from 'assests/Photos/Events/Dussasra/4.png'
// import p5 from 'assests/Photos/Events/Dussasra/5.png'
// import p6 from 'assests/Photos/Events/Dussasra/6.png'
// import p7 from 'assests/Photos/Events/Dussasra/7.png'
// import p8 from 'assests/Photos/Events/Dussasra/8.png'
// import p9 from 'assests/Photos/Events/Dussasra/9.png'
// import p10 from 'assests/Photos/Events/Dussasra/10.png'

// import p11 from 'assests/Photos/SchoolProgram/dassara/11.png'
const SidebarNewsletter = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url}/home/home-static/events/Dussasra/1.webp`;
  const p2 = `${config.base_image_url}/home/home-static/events/Dussasra/2.webp`;
  const p3 = `${config.base_image_url}/home/home-static/events/Dussasra/3.webp`;
  const p4 = `${config.base_image_url}/home/home-static/events/Dussasra/4.webp`;
  const p5 = `${config.base_image_url}/home/home-static/events/Dussasra/5.webp`;
  const p6 = `${config.base_image_url}/home/home-static/events/Dussasra/6.webp`;
  const p7 = `${config.base_image_url}/home/home-static/events/Dussasra/7.webp`;
  const p8 = `${config.base_image_url}/home/home-static/events/Dussasra/8.webp`;
  const p9 = `${config.base_image_url}/home/home-static/events/Dussasra/9.webp`;
  const p10 = `${config.base_image_url}/home/home-static/events/Dussasra/10.webp`;


  const photos = [
    {
      src: p1,
      source: p1,
      rows: 1,
      cols: 1,
    },
    {
      src: p2,
      source:p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p5,
      source:p5,
      rows: 1,
      cols: 1,
    },
    {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },
    {
      src: p7,
      source: p7,
      rows: 1,
      cols: 1,
    },
    {
      src: p8,
      source:p8,
      rows: 1,
      cols: 1,
    },
    {
      src: p9,
      source:p9,
      rows: 1,
      cols: 1,
    },

    {
      src: p10,
      source: p10,
      rows: 1,
      cols: 1,
    },

    // {
    //   src: p11,
    //   source: p11,
    //   rows: 1,
    //   cols: 1,
    // },

    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
        {/* <Button
          color="primary"
          size="large"
          endIcon={
            <svg
              width={16}
              height={16}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          }
          onClick={() => openLightbox(0)}
        >
          Open the gallery
        </Button> */}
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
  );
};

export default SidebarNewsletter;